import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgencyAddressSharingService } from '../agency-address-sharing.service';
import { ProposalStatusService } from '../proposal-status.service';
import { TopNavigationService } from '../top-navigation.service';
import { TopNavigationComponent } from './top-navigation.component';


@NgModule({
  declarations: [
    TopNavigationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    TopNavigationComponent,
  ],
  providers: [
    TopNavigationService,
    AgencyAddressSharingService,
    ProposalStatusService,
  ],
})
export class TopNavigationModule { }
